module.exports = __webpack_public_path__ + "media/img/search/bg_search_activities-3f26cc6358278165eedc2ffaed2aa0bd.png";